import { ref } from 'vue';

/**
 * Detects a triple-tap within a rolling 1500ms window.
 * Emits a single `triggered` event and resets on window expiry.
 */
const useSosGesture = (onTriggered: () => void, windowMs = 1500) => {
	const taps = ref<number[]>([]);
	const dotsLit = ref(0);

	const register = () => {
		const now = Date.now();
		taps.value = [...taps.value.filter(ts => now - ts <= windowMs), now];
		dotsLit.value = Math.min(taps.value.length, 3);

		if (taps.value.length >= 3) {
			taps.value = [];
			dotsLit.value = 3;
			onTriggered();
			// Reset the dots after a brief hold so the UI shows completion.
			setTimeout(() => {
				dotsLit.value = 0;
			}, 800);
		}
	};

	const reset = () => {
		taps.value = [];
		dotsLit.value = 0;
	};

	return {
		register,
		reset,
		dotsLit,
	};
};

export default useSosGesture;
